<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box">
                    <div class="box-body">
                        <v-server-table url="" :columns="columns" :options="options" name="keywords" ref="keywords"
                                        @loading="toggleLoading" @loaded="toggleLoading" @row-click="showKeyword">
                            <template slot="actions" slot-scope="props">
                                <div>
                                    <button class="btn btn-danger btn-sm" v-on:click.stop="remove(props.row.id)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </template>
                        </v-server-table>
                    </div>
                    <!-- /.box-body -->
                    <div class="overlay" v-show="loading">
                        <i class="fa fa-refresh fa-spin"></i>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import keywordsApi from '../../api/keywords'

  export default {
    data () {
      return {
        columns: [
          'keyword', 'actions'
        ],
        options: {
          sortable: [
            'keyword'
          ],
          requestFunction: function (query) {
            return keywordsApi.index(query)
          }
        },
        loading: false
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Keywords inserite',
        createButton: {
          display: true,
          text: 'Nuova keyword',
          to: 'keyword'
        }
      })
    },

    methods: {
      remove (id) {
        if (confirm('Sei sicuro di procedere?')) {
          this.loading = true
          keywordsApi.delete(id)
            .then((response) => {
              this.$refs.keywords.refresh()
              toastr.success('La keyword è stata rimossa correttamente')
              this.loading = false
            })
            .catch((response) => {
              this.loading = false
            })
        }
      },
      toggleLoading () {
        // this.loading = !this.loading
      },
      showKeyword (row) {
        this.$router.push({name: 'keywordsShow', params: {id: row.row.id}})
      }
    }
  }
</script>

<style>
    tr {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/keywords/Index.vue